import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export default function MergeClassNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
